import { useEffect, useState } from 'react'

export const useNetworkStatus = (
	pingUrl = 'https://exchange.synthetix.io/images/favicon.svg',
	verifyIntervalMs = 10000
) => {
	const [isOnline, setIsOnline] = useState(true)

	// Basic online/offline event listeners
	useEffect(() => {
		const handleOnline = () => setIsOnline(true)
		const handleOffline = () => setIsOnline(false)

		setIsOnline(navigator.onLine)

		window.addEventListener('online', handleOnline)
		window.addEventListener('offline', handleOffline)

		return () => {
			window.removeEventListener('online', handleOnline)
			window.removeEventListener('offline', handleOffline)
		}
	}, [])

	// Optional fallback verification with HEAD request
	useEffect(() => {
		const verifyConnection = async () => {
			try {
				await fetch(pingUrl, {
					method: 'HEAD',
					mode: 'no-cors',
					cache: 'no-store',
				})
				setIsOnline(true)
			} catch {
				setIsOnline(false)
			}
		}

		const interval = setInterval(verifyConnection, verifyIntervalMs)
		return () => clearInterval(interval)
	}, [pingUrl, verifyIntervalMs])

	return isOnline
}
